/**
 * Created by Andrey Popov on 12/5/25.
 */

const GrabInfoView = cc.Scale9Sprite.extend({
    ctor: function (options) {
        this._super(bundles.merge.frames.simple_info_bg);

        this.debugId = "GrabInfoView";

        this.setAnchorPoint(0.5, 0);
        this.setLocalZOrder(1);

        const styles = cleverapps.styles.GrabInfoView;
        const icon = new cc.Sprite(bundles.merge.frames.simple_info_grab);
        icon.setAlignment(this.width / 2, this.height / 2 + styles.iconDy);
        cleverapps.UI.fitToBox(icon, {
            width: this.width - styles.padding.x * 2,
            height: this.height - styles.padding.y * 2
        });
        this.addChild(icon);

        if (options.onClick && !cleverapps.environment.isSceneWithPreview()) {
            cleverapps.UI.onClick(this, this.createListener(options.onClick), {
                filter: function () {
                    return !options.unit.isLockedByTutorial();
                }
            });

            Map2d.currentMap.getMapView().watchInfoViewHovered(this);
        }

        if (cleverapps.gameModes.silentInfoView || cleverapps.config.demoMode) {
            this.setVisible(false);
        }

        const scale = connector.info.isMobile ? styles.mobileScale : styles.scale;
        this.setScale(scale);
        this.baseScale = scale;
    },

    runAnimation: function () {
        const styles = cleverapps.styles.GrabInfoView;
        this.stopAllActions();
        this.runAction(new cc.RepeatForever(
            new cc.Sequence(
                new cc.MoveBy(1, 0, styles.delta).easing(cc.easeInOut(1.7)),
                new cc.MoveBy(1, 0, -styles.delta).easing(cc.easeInOut(1.7))
            )
        ));
    }
});

cleverapps.styles.GrabInfoView = {
    mobileScale: 1.7,
    scale: 1.3,
    delta: 10,
    iconDy: 6,

    padding: {
        x: 10,
        y: 4
    }
};